import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { USER_ROLES } from '../../constants/userRoles';

function MedicoRoute({ children }) {
    const { user } = useAuth();

    if (user?.rol !== USER_ROLES.MEDICO) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default MedicoRoute;
